module.exports = __webpack_public_path__ + "img/zoetrope8.aa6ea4c7.png";